import { DeploymentRequestField } from "@/api/client";

interface DynamicFormFieldProps {
  field: DeploymentRequestField;
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

export default function DynamicFormField({
  field,
  value,
  onChange,
  error,
}: DynamicFormFieldProps) {
  const inputClassName = `input ${error ? "border-red-500" : ""}`;

  const renderInput = () => {
    switch (field.field_type) {
      case "textarea":
        return (
          <textarea
            id={field.slug}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className={inputClassName}
            placeholder={field.placeholder}
            rows={3}
            required={field.is_required}
          />
        );

      case "select":
        return (
          <select
            id={field.slug}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className={inputClassName}
            required={field.is_required}
          >
            <option value="">
              {field.placeholder || `Select ${field.name}...`}
            </option>
            {(field.options || []).map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        );

      case "url":
        return (
          <input
            type="url"
            id={field.slug}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className={inputClassName}
            placeholder={field.placeholder || "https://..."}
            required={field.is_required}
          />
        );

      case "email":
        return (
          <input
            type="email"
            id={field.slug}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className={inputClassName}
            placeholder={field.placeholder || "email@example.com"}
            required={field.is_required}
          />
        );

      case "number":
        return (
          <input
            type="number"
            id={field.slug}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className={inputClassName}
            placeholder={field.placeholder}
            required={field.is_required}
          />
        );

      case "date":
        return (
          <input
            type="date"
            id={field.slug}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className={inputClassName}
            required={field.is_required}
          />
        );

      case "text":
      default:
        return (
          <input
            type="text"
            id={field.slug}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className={inputClassName}
            placeholder={field.placeholder}
            required={field.is_required}
          />
        );
    }
  };

  return (
    <div>
      <label htmlFor={field.slug} className="label">
        {field.name}
        {field.is_required && <span className="text-red-500 ml-1">*</span>}
      </label>
      {renderInput()}
      {field.description && (
        <p className="mt-1 text-xs text-gray-500">{field.description}</p>
      )}
      {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
}
